export default Object.freeze({
  Retryable: 0,
  NonRetryable: 1,
  ManualReview: 2,
});
